
    <div class="switch {{cssClass}} {{size ? 'btn-' + size : ''}}" (click)="toggle()" [ngClass]="{'disabled': disabled}"><span class="switch-left {{checked ? 'bg-'+ type + ' active' : ''}}">{{onText}} </span><span class="switch-right {{!checked ? 'bg-'+ type + ' active' : ''}}">{{offText}}</span></div>
  